<div class="wrapper">
    <app-header></app-header>
    <app-side-menu></app-side-menu>
    <div class="content-wrapper">
        <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
</div>
